<script setup lang="ts">
import { isPlatform } from '@ionic/vue'
import { onMounted, ref } from 'vue'
import logo from '@/assets/logo.png'
import { openSekaiInApp, openStoreLink } from '@/utils/outterUrlUtils'

const installedApp = ref(true)
const isShareMode = ref(false)

onMounted(() => {
  const isShare = new URLSearchParams(window.location.search).get('__share__') === 'true'
  isShareMode.value = isShare
  if (isShare) {
    return
  }
  console.debug(window.navigator.userAgent)
  // bring up the app store or google play store
  openSekaiInApp()
  setTimeout(() => {
    if (document.hidden || (document as any).webkitHidden) {
      // App可能已经打开，不做任何操作
    }
    else {
      // 可能没有安装App，跳转到App Store
      installedApp.value = false
    }
  }, 2000) // 等待2秒
})
</script>

<template>
  <div v-if="!isShareMode" class="flex flex-center items-center bg p-4 gap-4">
    <img class="w-12 h-12 rd-4" :src="logo" alt="Sekai">
    <div class="flex flex-col gap-2">
      <p class="text-3 leading-1.2 fw-700">
        Sekai
      </p>
      <p class="text-2.5 fw-500 text-nowrap">
        Live in your Fanfiction
      </p>
    </div>
    <a class="btn-primary text-2.5 py-1 h-auto" target="_blank" @click="installedApp ? openSekaiInApp(undefined, true) : openStoreLink()">
      Open {{ installedApp ? `in Sekai app` : `${isPlatform("ios") ? "App Store" : "Google Play"}` }}
    </a>
  </div>
</template>

<style scoped>
.bg {
  background-color: rgba(255, 255, 255, 0.6);
}
</style>
